// evaluates a list of roles with a subset to see any of the subset are in the main list
export const evaluate = (roles, rolesToEvaluate) => {
    if (!rolesToEvaluate) return true;
    return roles && roles.some(c=> rolesToEvaluate.indexOf(c) >= 0)
}